import React from 'react';
import classnames from 'classnames';

import styles from './ModalTabs.scss';

export default function ModalTabs({ selectedValue, tabs, onChange }) {
  return (
    <div className={styles.wrapper}>
      {tabs.map(({ label, value }) => (
        <button
          type="button"
          key={value}
          className={classnames(styles.tab, { [styles.selected]: selectedValue === value })}
          onClick={selectedValue === value ? undefined : () => onChange(value)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

ModalTabs.propTypes = {
  tabs: React.PropTypes.arrayOf(
    React.PropTypes.shape({
      label: React.PropTypes.node.isRequired,
      value: React.PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedValue: React.PropTypes.string.isRequired,
  onChange: React.PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modal/components/ModalTabs.jsx